import { Component } from 'react';

export class ListSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                xmlns="http://www.w3.org/2000/svg"
                data-testid="ListSVG"
                viewBox="0 0 17 17"
            >
                <path
                    d="M3.6 13.5c0 .5-.2.9-.5 1.3-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5c-.3-.3-.5-.8-.5-1.3s.2-.9.5-1.3c.4-.4.8-.5 1.3-.5s.9.2 1.3.5c.4.4.5.8.5 1.3zm0-4.8c0 .5-.2.9-.5 1.3-.4.4-.8.5-1.3.5S.9 10.3.5 10C.2 9.6 0 9.2 0 8.7s.2-.9.5-1.3.8-.5 1.3-.5 1 .1 1.3.5.5.8.5 1.3zM17 12.6v1.8c0 .1 0 .2-.1.2-.1.1-.1.1-.2.1H5.2c-.1 0-.2 0-.2-.1-.1-.1-.1-.1-.1-.2v-1.8c0-.1 0-.2.1-.2s.1-.1.2-.1h11.5c.1 0 .2 0 .2.1.1.1.1.1.1.2zM3.6 3.8c0 .5-.2.9-.5 1.3s-.8.5-1.3.5-.9-.1-1.3-.5S0 4.3 0 3.8s.2-.9.5-1.3.8-.5 1.3-.5.9.2 1.3.5.5.8.5 1.3zm13.4 4v1.8c0 .1 0 .2-.1.2-.1.1-.1.1-.2.1H5.2c-.1 0-.2 0-.2-.1s-.1-.1-.1-.2V7.8c0-.1 0-.2.1-.2 0-.1.1-.1.2-.1h11.5c.1 0 .2 0 .2.1.1 0 .1.1.1.2zm0-4.9v1.8c0 .1 0 .2-.1.2-.1.1-.1.1-.2.1H5.2c-.1 0-.2 0-.3-.1v-2c0-.1 0-.2.1-.2s.1-.1.2-.1h11.5c.1 0 .2 0 .2.1.1.1.1.1.1.2z"
                    fill="#565656"
                />
            </svg>
        );
    }
}
